import React from 'react'
import { get } from 'lodash'

import config from 'config'
import {
  PaymentCanceled,
  PaymentInit,
  PaymentSuccess,
  PaymentFail
} from 'containers/pages'

const urlPrefix = `${config.publicPath}`

export default [
  {
    path: `${urlPrefix}/mpg-init/:authCode`,
    exact: true,
    component: props => (
      <PaymentInit
        {...props}
        params={get(props, 'match.params', {})}
      />
    ),
    routes: []
  },
  {
    path: `${urlPrefix}/mastercard-online-payments/success/:id?`,
    exact: true,
    component: props => (
      <PaymentSuccess
        {...props}
        params={get(props, 'match.params', {})}
      />
    ),
    routes: []
  },
  {
    path: `${urlPrefix}/mastercard-online-payments/failure/:id?`,
    exact: true,
    component: props => (
      <PaymentFail
        {...props}
        params={get(props, 'match.params', {})}
      />
    ),
    routes: []
  },
  {
    path: `${urlPrefix}/mastercard-online-payments/cancel/:id?`,
    exact: true,
    component: props => (
      <PaymentCanceled
        {...props}
        params={get(props, 'match.params', {})}
      />
    ),
    routes: []
  }
]

